module.exports = __webpack_public_path__ + "img/logo9.227bbde9.jpg";